import * as Yup from 'yup';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { IconButton, InputAdornment, Link, Stack } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/Iconify';
import { FormProvider, RHFCheckbox, RHFTextField } from '../../../components/hook-form';
import { loginUsername } from 'src/axiosLib/services/admin';
import { get } from 'lodash';
import { getDashboardBase } from 'src/util/helpers';
// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);
  const [studentInfo, setStudentInfo] = useState({});

  const LoginSchema = Yup.object().shape({
    email: Yup.string().ensure('Username/password not found').required('username/phone is required'),
    password: Yup.string().required('username/phone not found'),
  });

  const defaultValues = {
    email: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async () => {
    // navigate('/dashboard/app', { replace: true });
  };

  const handlelogin=(studentInfo)=>{

    // console.log("ADMIN")

    loginUsername(studentInfo, (err,data)=>{  
      if(!err){
        localStorage.setItem('jwtToken', data.token);
        localStorage.setItem('type', "admin");

        navigate(getDashboardBase() + '/app', { replace: true });
      }
    })
  }

  const handleChange = (fieldName, event) =>{
    setStudentInfo({...studentInfo, [fieldName] : event.target.value});
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="username" label="Phone/User Name" type="text" value={get(studentInfo, 'username', '')}
        onChange={(e) =>{handleChange('username', e)}}
        />

        <RHFTextField
          name="password"
          label="Password"
          type={showPassword ? 'text' : 'password'}
          onChange={(e) =>{handleChange('password', e)}}
          value={get(studentInfo, 'password', '')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting} onClick={(e)=> {handlelogin(studentInfo)}}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
